import { useCallback } from 'react';
import { useTemplateEditorDispatch, useTemplateEditorState } from '../context/UseTemplateEditorContext';
import {
  IOffsiteTemplatePreviewResponse,
  OnsiteTemplatePreviewQueryResponse,
} from 'sections/design/template-management/entities/templates';

export const useUpdatePreview = (response: IOffsiteTemplatePreviewResponse | OnsiteTemplatePreviewQueryResponse) => {
  const dispatch = useTemplateEditorDispatch();
  const { template, compilationContext } = useTemplateEditorState();

  return useCallback(() => {
    localStorage.setItem('templateEditorPreview', response.compiled);
    dispatch({
      type: 'UPDATE_PREVIEW',
      payload: {
        compiledTemplate: response.compiled,
        precompiledLinks: (response as IOffsiteTemplatePreviewResponse).precompiledLinks ?? [],
        transformedLinks: (response as IOffsiteTemplatePreviewResponse).transformedLinks ?? [],
        lastCompiledCompilationContext: (response as OnsiteTemplatePreviewQueryResponse).compilationContext
          ? { compilationContext: (response as OnsiteTemplatePreviewQueryResponse).compilationContext }
          : compilationContext,
        compilationContext: (response as OnsiteTemplatePreviewQueryResponse).compilationContext
          ? { compilationContext: (response as OnsiteTemplatePreviewQueryResponse).compilationContext }
          : compilationContext,
        lastCompiledTemplateBody: template.template,
      },
    });
  }, [compilationContext, dispatch, response, template.template]);
};
